var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.3334 5.08332H3.26094L5.90094 2.44332C6.25844 2.08582 6.25844 1.50832 5.90094 1.15082C5.54344 0.793315 4.96594 0.793315 4.60844 1.15082L0.400937 5.35832C0.0434375 5.71582 0.0434375 6.29332 0.400937 6.65082L4.60844 10.8583C4.96594 11.2158 5.54344 11.2158 5.90094 10.8583C6.25844 10.5008 6.25844 9.92332 5.90094 9.56582L3.26094 6.91665H15.3334C15.8376 6.91665 16.2501 6.50415 16.2501 5.99998C16.2501 5.49582 15.8376 5.08332 15.3334 5.08332Z","fill":"#135FD2"}));
}

Arrow.defaultProps = {"width":"17","height":"12","viewBox":"0 0 17 12","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
